module.exports = __webpack_public_path__ + "img/ellinor.4092c4b6.jpeg";